import { useContext } from "react"
import dynamic from "next/dynamic"
import Logo from "../icons/Logo"
import { screenSizeContext } from "@/app/store/context/screenSizesContext"
import CustomButton from "../CustomButton"
import QuickLinks from "./QuickLinks"
import { useNavigation } from "@/app/hooks/useNavigation"
import Link from "../Link"
import { useGetInTouchPopupContext } from "@/app/store/context/getInTouchPopupContext"
import * as gtag from "@/app/utils/gtag"

const FooterSubscribe = dynamic(() => import("./FooterSubscribe"), {
	ssr: false,
	loading: () => (
		<div className="text-white mb-4 font-bodyM font-national text-bodyM font-normal min-h-[5rem]" aria-hidden />
	),
})

const FooterBodyComponent = () => {
	// const pathname = usePathname();
	const router = useNavigation()
	const { isMobile } = useContext(screenSizeContext);
	const { openGetInTouchPopup } = useGetInTouchPopupContext();
	// const {setIsPageFetched} = useContext(loadingContext)

	const quickLinksData1 = [
		{
			label: "Homepage",
			route: "/",
		},
		{
			label: "About Us",
			route: "/about-us",
		},
		{
			label: "Neighborhoods",
			route: "/neighborhoods",
		},
	]
	const quickLinksData2 = [
		{
			label: "Amenities",
			route: "/amenities",
		},
		{
			label: "Partners",
			route: "/partners",
		},
		// {
		// 	label: "Construction Update ",
		// 	route: "/construction-updates",
		// },
		{
			label: "Media Center",
			route: "/media-center",
		},
	]
	return (
		<div className="flex justify-between items-start flex-col lg:flex-row ">
			<div className="footer_logo  flex-none w-[98%] lg:w-[34%] pb-6 lg:pb-0 ">
				{isMobile ? (
					<Link href="/" aria-label="O West home">
						<Logo width={274} height={65} />
					</Link>
				) : (
					<Link href="/" aria-label="O West home">
						<Logo width={340} height={60.09} />
					</Link>
				)}
			</div>
			<div className="footer_wrapper flex-none w-[100%] lg:w-[66%] ">
				<div
					className="footer_content flex justify-around lg:justify-between w-[100%] lg:w-[74%] mb-[5rem] lg:mb-[8.75rem]"
					style={{ marginInlineStart: "auto" }}
				>
					<div className="content-col lg:flex-1  w-50">
						<QuickLinks data={quickLinksData1} />
					</div>
					<div className="content-col lg:flex-1  w-50">
						<QuickLinks data={quickLinksData2} />
					</div>
				</div>
				<div className="footer_row flex flex-col lg:flex-row justify-between items-end mb-[5rem] lg:mb-[8.75rem]">
					<div className="footer_buttons flex flex-row w-[100%] xl:w-[50%] lg:w-[60%] justify-center lg:justify-center gap-6 mb-16 lg:mb-0 ">
						<div className="booking">
							<CustomButton 
								text="Buy now" 
								hasIcon 
								style="white" 
								action={() => {
									gtag.conversion('s22iCL--jN8bELy50MNC');
									openGetInTouchPopup();
								}} 
								customClass="!p-2 !ps-5 tracking-[0.07rem]" 
							/>
						</div>
						<div className="contactUs">
							<CustomButton 
								text="Contact Us" 
								hasIcon 
								style="transparent" 
								action={() => router.push("/contact-us", "book=true")} 
								customClass="!p-2 !ps-5 tracking-[0.07rem]"
							/>
						</div>
					</div>
					<div className="footer_subscribe flex justify-between items-center w-[100%] xl:w-[50%] lg:w-[40%]">
						<FooterSubscribe />
					</div>
				</div>
			</div>
		</div>
	)
}

export default FooterBodyComponent
